
import { environment } from 'src/environments/environment';

export class CandidatesCertificates {
  private id: number;
  private libelle: string;
  private filePath: string;

  constructor(CandidatesCertificates: any) {
    this.id = CandidatesCertificates.id;
    this.libelle = CandidatesCertificates.libelle;
    this.filePath = CandidatesCertificates.filePath;
  }

  getId(): number {
    return this.id;
  }

  getLibelle(): string {
    return this.libelle;
  }

  getFilePath(): string {
    return (this.filePath != null && this.filePath != '') ? environment.apiUrl + this.filePath : this.filePath;
  }
}